/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
/**
 * Check if a given object implements the AggregatedStat interface.
 */
export function instanceOfAggregatedStat(value) {
    return true;
}
export function AggregatedStatFromJSON(json) {
    return AggregatedStatFromJSONTyped(json, false);
}
export function AggregatedStatFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'min': json['Min'] == null ? undefined : json['Min'],
        'max': json['Max'] == null ? undefined : json['Max'],
        'avg': json['Avg'] == null ? undefined : json['Avg'],
    };
}
export function AggregatedStatToJSON(json) {
    return AggregatedStatToJSONTyped(json, false);
}
export function AggregatedStatToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Min': value['min'],
        'Max': value['max'],
        'Avg': value['avg'],
    };
}
